export default __webpack_public_path__ + "static/media/TimothyWang.49669000.png";